import { render, staticRenderFns } from "./DasAccessories.vue?vue&type=template&id=1ff3adec&"
import script from "./DasAccessories.vue?vue&type=script&lang=js&"
export * from "./DasAccessories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ff3adec')) {
      api.createRecord('1ff3adec', component.options)
    } else {
      api.reload('1ff3adec', component.options)
    }
    module.hot.accept("./DasAccessories.vue?vue&type=template&id=1ff3adec&", function () {
      api.rerender('1ff3adec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/DasAccessories.vue"
export default component.exports